import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { AreaSituacaoModule } from '../situacao';

import { AreaFilterComponent } from './area-filter.component';

@NgModule({
    imports: [
        SharedModule,
        AreaSituacaoModule
    ],
    declarations: [
        AreaFilterComponent
    ],
    exports: [
        AreaFilterComponent
    ]
})
export class AreaFilterModule { }
